import { ClerkProvider } from "@clerk/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { EntityLabelsProvider } from "./hooks/useEntityLabels";
import { rootRoute } from "./routes/__root";
import { appsRoute } from "./routes/apps";
import { indexRoute } from "./routes/index";
import { rulesRoute } from "./routes/rules";
import { createRuleRoute } from "./routes/rules.create";
import { editRuleRoute } from "./routes/rules.edit";
import { subscribeRoute } from "./routes/subscribe";

const routeTree = rootRoute.addChildren([
	indexRoute,
	rulesRoute,
	createRuleRoute,
	editRuleRoute,
	appsRoute,
	subscribeRoute,
]);
const router = createRouter({ routeTree });

const queryClient = new QueryClient();

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<ClerkProvider afterSignOutUrl="/" publishableKey={clerkPublishableKey}>
			<QueryClientProvider client={queryClient}>
				<EntityLabelsProvider>
					<RouterProvider router={router} />
				</EntityLabelsProvider>
			</QueryClientProvider>
		</ClerkProvider>
	</StrictMode>,
);
